module.exports = __webpack_public_path__ + "media/images/bg_logo-ce20ef86cd6ce2eb1bef50b273946bc7.png";